# TODO: brittany 10/4 - Stale? The selector #js-indeed-external is nowhere to be found elsewhere in the codebase,
# and the Get Candidates Faster button (Indeed Premium Posting) does not use this

$( ->
  $('#js-indeed-external').on 'click', ->
    indeedLink = $(this).attr("data-indeed")
    $($(this).closest('.modal-body').replaceWith("<iframe src=#{indeedLink} height=98% width=98%></iframe>"))
)
